import sanitizeHtml from 'sanitize-html';

export const sanitizeUrl = (text: string) => {
  // Sanitize url
  const sanitizedUrl = sanitizeHtml(text, {
    allowedTags: [],
    allowedAttributes: {},
  });

  return sanitizedUrl;
};
